export default "__VITE_ASSET__428b36ce__"